import { Canvas } from "react-three-fiber";
import { Stats, Cone } from "drei";
import SETTINGS from "../../settings";

import Lights from "./lights";
import CameraControls from "./camera-controls";
// import Ground from "./ground";

import log from "loglevel";

const ThreeWorld = (props) => {
  return (
    <group position={[0, 0.1, 0]} rotation={[0, 0, 0]}>
      <Cone
        castShadow
        args={[0.025, 0.1, 12]}
        position={[0, 0, -1]}
        rotation={[-Math.PI / 2, 0, 0]}
      >
        <meshLambertMaterial attach="material" color={0xaa0000} />
      </Cone>
      {props.children}
    </group>
  );
};

const World = (props) => {
  // log.info(props);
  return (
    <Canvas
      // orthographic
      camera={{
        fov: 35,
        position: [
          0,
          props.size / SETTINGS.TERRAIN.SCALE,
          (props.size * 1.5) / SETTINGS.TERRAIN.SCALE,
        ],
      }}
      shadowMap={true}
      background={0xddffee}
      invalidateFrameloop
    >
      {/* <fog attach="fog" args={["white", props.size, props.size * 8]} /> */}
      <Lights
        latitude={props.latitude}
        time={props.controlData.time}
        date={props.controlData.date}
        size={props.size}
        scale={SETTINGS.TERRAIN.SCALE}
      />
      <CameraControls size={props.size} scale={SETTINGS.TERRAIN.SCALE} />
      <ThreeWorld {...props} />
      {/* <Ground size={props.size} /> */}
      {props.grid && <gridHelper />}
      {props.stats && <Stats />}
    </Canvas>
  );
};

export default World;
